import middleware from "../../middleware";
class WeaCustom extends React.Component {
  render() {
    return <div />;
  }
}

const Com = middleware(WeaCustom, "WeaCustom");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-custom/index.js